import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OnboardingClient } from '../shared/models/onboarding/onboarding-client';
import { OnboardingCategory } from '../shared/models/onboarding/onboarding-category';
import { StepChanged } from '../shared/models/onboarding/step-changed';
import { ClientListResponse } from '../shared/models/onboarding/client-list-response';
import { ClientNoteResponse } from '../shared/models/note/client-note-reponse';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/onboarding/';
  constructor(private http: HttpClient) {}

  public GetOnboardingClients(onlyOnboardedCompleted: boolean): Observable<ClientListResponse> {
    return this.http.get<ClientListResponse>(`${this.apiUrl}clients/${onlyOnboardedCompleted}`);
  }

  public GetOnboardingClientInformation(clientId: number): Observable<OnboardingClient> {
    return this.http.get<OnboardingClient>(`${this.apiUrl}client/${clientId}`);
  }

  public GetAllCategoriesAndSteps(): Observable<OnboardingCategory[]> {
    return this.http.get<OnboardingCategory[]>(`${this.apiUrl}steps`);
  }

  public UpdateStep(clientId: number, stepId: number, complete: boolean, updatedByUserId: number): Observable<StepChanged> {
    const changeStepRequest = {
      clientId: clientId,
      stepId: stepId,
      isComplete: complete,
      updatedByUserId: updatedByUserId,
    };
    return this.http.post<StepChanged>(`${this.apiUrl}client/update-step`, changeStepRequest);
  }

  public MarkEmailStepAsSent(clientId: number, stepId: number, updatedByUserId: number): Observable<StepChanged> {
    const changeStepRequest = {
      clientId: clientId,
      stepId: stepId,
      isComplete: true,
      updatedByUserId: updatedByUserId,
      MarkAsSent: true,
    };
    return this.http.post<StepChanged>(`${this.apiUrl}client/update-step`, changeStepRequest);
  }

  public GetArchivedClients(): Observable<ClientListResponse> {
    return this.http.get<ClientListResponse>(`${this.apiUrl}clients/archived`);
  }

  public CompleteOnboarding(clientId: number, updatedByUserId: number): Observable<ClientNoteResponse> {
    const completeOnboardingRequest = {
      clientId: clientId,
      actionByUserId: updatedByUserId,
    };
    return this.http.post<ClientNoteResponse>(`${this.apiUrl}client/complete`, completeOnboardingRequest);
  }

  public RestartOnboarding(clientId: number, updatedByUserId: number): Observable<ClientNoteResponse> {
    const restartRequest = {
      clientId: clientId,
      actionByUserId: updatedByUserId,
    };
    return this.http.post<ClientNoteResponse>(`${this.apiUrl}client/restart`, restartRequest);
  }

  public ArchiveAndUnonboard(clientId: number, updatedByUserId: number): Observable<any> {
    const archiveAndUnonboardRequest = {
      clientId: clientId,
      actionByUserId: updatedByUserId,
    };
    return this.http.post<any>(`${this.apiUrl}client/archive-and-unonboard`, archiveAndUnonboardRequest);
  }
}
